export const DESKTOP_SCREEN_CUTOFF = 1024;
